import { api } from "@/lib/api";
import { type Schemas } from "@/types";
import { useQuery } from "react-query";

export default function AppointmentTabQuery() {
  const { data } = useQuery({
    queryKey: ["appointmentTabStats"],
    queryFn: async () => {
      const response = await api.get<Schemas["AppointmentTabStats"]>(
        "/api/Reports/AppointmentTabStats",
      );
      return response.data;
    },
  });

  return {
    totalCount: data?.totalOpenAppointments,
    totalCompleted: data?.totalCompletedToday,
  };
}
